import React from 'react';
import { Icon } from '@iconify/react';
import '../../../dist/assets/stylesheets/css/legacyAnalytics.css';

/** Warning for sessions the lab flagged with unreliable 3D triangulation. */
function LegacyTriangulationBadge({ compact = false }) {
  return (
    <span
      className="legacy-warning-badge"
      role="note"
      title="The lab flagged this session's 3D triangulation as unreliable. Angles may be off."
    >
      <Icon icon="mdi:alert-outline" aria-hidden="true" />
      {compact ? 'Bad triangulation' : 'Bad triangulation: angles may be unreliable'}
    </span>
  );
}

export default LegacyTriangulationBadge;
